import Logo from "./agora-logo.svg";
const AgoraLogo = (props) => {
  return <img src={Logo} alt="logo-image" {...props} />;
};

export default AgoraLogo;
